import React from 'react';

export const JobPostSkeleton = () => {
  return (
    <div className='max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-16'>
      <div className='grid grid-cols-1 lg:grid-cols-3 gap-8'>
        { /* Main Content Loading */ }
        <div className='lg:col-span-2 space-y-8'>
          { /* Job Info Cards Skeleton */ }
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            { [1, 2, 3, 4].map((item) => (
              <div
                  key={item}
                  className='bg-white rounded-2xl p-6 shadow-sm border border-gray-100'
              >
                <div className='flex items-center gap-3'>
                  <div className='w-10 h-10 bg-gray-200 rounded-xl animate-pulse'></div>
                  <div className='flex-1'>
                    <div className='h-3 bg-gray-200 rounded animate-pulse mb-2'></div>
                    <div className='h-4 bg-gray-200 rounded animate-pulse w-3/4'></div>
                  </div>
                </div>
              </div>
            )) }
          </div>

          { /* Job Description Skeleton */ }
          <div className='bg-white rounded-2xl p-8 shadow-sm border border-gray-100'>
            <div className='h-6 bg-gray-200 rounded animate-pulse mb-6 w-1/3'></div>
            <div className='space-y-3'>
              <div className='h-4 bg-gray-200 rounded animate-pulse'></div>
              <div className='h-4 bg-gray-200 rounded animate-pulse w-5/6'></div>
              <div className='h-4 bg-gray-200 rounded animate-pulse w-4/5'></div>
              <div className='h-4 bg-gray-200 rounded animate-pulse w-3/4'></div>
            </div>
          </div>
        </div>

        { /* Sidebar Loading */ }
        <div className='lg:col-span-1 space-y-6'>
          <div className='bg-white rounded-2xl p-6 shadow-sm border border-gray-100'>
            { /* Apply Section Skeleton */ }
            <div className='bg-gray-100 rounded-xl p-6 text-center mb-6 animate-pulse'>
              <div className='h-5 bg-gray-200 rounded mb-2 w-2/3 mx-auto'></div>
              <div className='h-3 bg-gray-200 rounded mb-4 w-3/4 mx-auto'></div>
              <div className='h-10 bg-gray-200 rounded w-full'></div>
            </div>

            { /* Share Section Skeleton */ }
            <div className='space-y-4'>
              <div className='text-center mb-6'>
                <div className='h-4 bg-gray-200 rounded mb-2 w-3/4 mx-auto'></div>
                <div className='h-3 bg-gray-200 rounded w-2/3 mx-auto'></div>
              </div>

              <div className='grid grid-cols-2 gap-3'>
                <div className='h-12 bg-gray-100 rounded-xl animate-pulse'></div>
                <div className='h-12 bg-gray-100 rounded-xl animate-pulse'></div>
              </div>

              <div className='border-t border-gray-100 pt-4'>
                <div className='grid grid-cols-2 gap-3'>
                  { [1, 2, 3, 4].map((item) => (
                    <div key={item} className='h-12 bg-gray-100 rounded-xl animate-pulse'></div>
                  )) }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      { /* Loading Message */ }
      <div className='text-center mt-8'>
        <div className='flex items-center justify-center space-x-2 text-gray-600'>
          <svg
              className='animate-spin h-5 w-5'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
          >
            <circle
                className='opacity-25'
                cx='12'
                cy='12'
                r='10'
                stroke='currentColor'
                strokeWidth='4'
            ></circle>
            <path
                className='opacity-75'
                fill='currentColor'
                d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
            ></path>
          </svg>
          <span>Loading job details...</span>
        </div>
      </div>
    </div>
  );
};
